import React, { useEffect, useState } from "react";
import "./userFilter.scss";
import {
  AppBar,
  Avatar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";

// Date Picker
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Date Picker

// Icon
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import usersStore from "../../../stores/usersStore";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UserFilter = ({
  userName,
  setUserName,
  email,
  setEmail,
  phoneNo,
  setPhoneNo,
  gender,
  setGender,
  status,
  setStatus,
  staringDate,
  setStaringDate,
  endingDate,
  setEndingDate,
}) => {
  const UsersStore = usersStore();
  const max_width600 = useMediaQuery("(max-width:600px)");
  const max_width900 = useMediaQuery("(max-width:900px)");
  const [open, setOpen] = useState(false);
  const [endingDateError, setEndingDateError] = useState(false);

  const todayDate = new Date();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    let flag = true;
    if (
      userName === "" &&
      email === "" &&
      phoneNo === "" &&
      gender === "" &&
      status === "" &&
      staringDate === null &&
      endingDate === null
    ) {
      UsersStore.setUserFilterApply({ value: 0 });
    } else {
      if (staringDate !== null) {
        if (endingDate === null) {
          flag = false;
          setEndingDateError(true);
        } else {
          setEndingDateError(false);
        }
      }

      if (flag) {
        UsersStore.setUserFilterApply({
          value: ++UsersStore.userFilterApply,
        });
      }
    }
    if (flag) {
      handleClose();
    }
  };

  const clearAll = () => {
    UsersStore.setUserFilterApply({ value: 0 });
    setUserName("");
    setEmail("");
    setPhoneNo("");
    setGender("");
    setStatus("");
    setStaringDate(null);
    setEndingDate(null);
  };

  return (
    <div className="user-filter">
      <div className="filter-btn">
        <Chip
          avatar={
            <Avatar className="avatar">
              <FilterListRoundedIcon className="icon" />
            </Avatar>
          }
          label={<p>Filter</p>}
          variant="outlined"
          onClick={handleClickOpen}
        />
      </div>
      <Dialog
        fullScreen={max_width600 ? true : false}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="md"
      >
        {max_width600 ? (
          <AppBar sx={{ position: "relative" }}>
            <Toolbar style={{ background: "#000" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseRoundedIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Search Filter
              </Typography>
              <Button autoFocus color="inherit" onClick={handleApply}>
                Apply
              </Button>
            </Toolbar>
          </AppBar>
        ) : (
          <DialogTitle>Search Filter</DialogTitle>
        )}
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  disabled={UsersStore.userFilterApply === 0 ? true : false}
                  onClick={clearAll}
                >
                  Clear All
                </Button>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Username"
                variant="outlined"
                fullWidth
                name="username"
                value={userName}
                onChange={(e) => {
                  const { value } = e.target;
                  setUserName(value);
                }}
                InputProps={{
                  endAdornment: userName !== "" && (
                    <IconButton size="small" onClick={() => setUserName("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                value={email}
                onChange={(e) => {
                  const { value } = e.target;
                  setEmail(value);
                }}
                InputProps={{
                  endAdornment: email !== "" && (
                    <IconButton size="small" onClick={() => setEmail("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Phone No"
                variant="outlined"
                fullWidth
                name="phoneNo"
                value={phoneNo}
                onChange={(e) => {
                  const { value } = e.target;
                  setPhoneNo(value);
                }}
                InputProps={{
                  endAdornment: phoneNo !== "" && (
                    <IconButton size="small" onClick={() => setPhoneNo("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="gender-select">Gender</InputLabel>
                <Select
                  labelId="gender-select"
                  value={gender}
                  label="Gender"
                  onChange={(e) => {
                    if (e.target.value === "clear") {
                      setGender("");
                    } else {
                      setGender(e.target.value);
                    }
                  }}
                >
                  <MenuItem
                    value="clear"
                    disabled={gender === "" ? true : false}
                  >
                    Clear
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Not Define">Not Define</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <p>Joining Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Starting Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="startingDate"
                    value={staringDate}
                    onChange={(value) => {
                      setStaringDate(value);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {staringDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => {
                    setStaringDate(null);
                    setEndingDateError(false);
                  }}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <p style={{ marginTop: max_width900 ? 0 : "22px" }}></p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Ending Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="endingDate"
                    value={endingDate}
                    onChange={(value) => {
                      setEndingDate(value);
                      setEndingDateError(false);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {endingDateError && (
                <FormHelperText color="error">
                  ending date is required
                </FormHelperText>
              )}
              {endingDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => setEndingDate(null)}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="status-select">Status</InputLabel>
                <Select
                  labelId="status-select"
                  value={status}
                  label="Status"
                  onChange={(e) => {
                    if (e.target.value === "clear") {
                      setStatus("");
                    } else {
                      setStatus(e.target.value);
                    }
                  }}
                >
                  <MenuItem
                    value="clear"
                    disabled={status === "" ? true : false}
                  >
                    Clear
                  </MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Banned">Banned</MenuItem>
                  <MenuItem value="Deleted">Deleted</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        {!max_width600 && (
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleApply}>Apply</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

export default UserFilter;
